import * as ActionTypes from './actionTypes';
import apiActionCreator from '../../common/service/api/actionCreator';
import {buildErrorMessage} from '../../common/util/errorUtils';
import {getUrlParameters} from '../../common/util/urlParameters';
import {addMessageBoxInfo} from '../../common/messageBox/actions/actions';
import {paths} from '../../common/dictionaries/urls';
import {navigateTo} from '../../router/actions';

export const getPartsReturnOrders = (filters) => {
  const searchFilters = getUrlParameters(filters);

  return apiActionCreator({
    'endpoint': `/parts/returns${searchFilters}`,
    'authenticated': true,
    'types': [
      ActionTypes.GET_PART_RETURNS_ORDERS_REQUEST,
      ActionTypes.GET_PART_RETURNS_ORDERS_SUCCESS,
      [ActionTypes.GET_PART_RETURNS_ORDERS_FAILED, (error) => buildErrorMessage(error)],
    ],
    'microservice': 'part',
    'method': 'GET',
  });
};

export const getPartsReturnDetail = (returnCode) => apiActionCreator({
  'endpoint': `/parts/returns/${returnCode}`,
  'authenticated': true,
  'types': [
    ActionTypes.GET_PART_RETURN_DETAIL_REQUEST,
    ActionTypes.GET_PART_RETURN_DETAIL_SUCCESS,
    [ActionTypes.GET_PART_RETURN_DETAIL_FAILED, (error) => buildErrorMessage(error)],
  ],
  'microservice': 'part',
  'method': 'GET',
});

export const createPartsReturnOrder = (data) => apiActionCreator({
  'endpoint': '/parts/returns',
  'authenticated': true,
  'types': [
    ActionTypes.CREATE_PARTS_RETURN_ORDER_REQUEST,
    [
      ActionTypes.CREATE_PARTS_RETURN_ORDER_SUCCESS,
      addMessageBoxInfo('Orden de devolución elaborada satisfactoriamente.'),
    ],
    [ActionTypes.CREATE_PARTS_RETURN_ORDER_REQUEST, (error) => buildErrorMessage(error)],
  ],
  'microservice': 'part',
  'method': 'POST',
  'contentType': 'application/json',
  'data': data,
});

export const deletePartsReturnOrder = (returnCode) => apiActionCreator({
  'endpoint': '/parts/returns',
  'authenticated': true,
  'types': [
    ActionTypes.DELETE_PARTS_RETURN_ORDER_REQUEST,
    [
      navigateTo(paths.PartsReturns),
      ActionTypes.DELETE_PARTS_RETURN_ORDER_SUCCESS,
      addMessageBoxInfo('Orden de devolución eliminada satisfactoriamente.'),
    ],
    [ActionTypes.DELETE_PARTS_RETURN_ORDER_FAILED, (error) => buildErrorMessage(error)],
  ],
  'microservice': 'part',
  'method': 'DELETE',
  'contentType': 'application/json',
  'data': {returnCode},
});

export const processPartsReturnOrder = (returnCode, detail, action) => apiActionCreator({
  'endpoint': `/parts/returns/${returnCode}`,
  'authenticated': true,
  'types': [
    ActionTypes.PROCESS_PARTS_RETURN_ORDER_REQUEST,
    [
      navigateTo(paths.PartsReturns),
      ActionTypes.PROCESS_PARTS_RETURN_ORDER_SUCCESS,
      addMessageBoxInfo('Orden de devolución actualizada satisfactoriamente.'),
    ],
    [ActionTypes.PROCESS_PARTS_RETURN_ORDER_FAILED, (error) => buildErrorMessage(error)],
  ],
  'microservice': 'part',
  'method': 'PATCH',
  'contentType': 'application/json',
  'data': {detail, action},
});

export const exportPartsReturnOrders = (filters) => {
  const searchFilters = getUrlParameters(filters);

  return apiActionCreator({
    'endpoint': `/parts/returns/reports${searchFilters}`,
    'authenticated': true,
    'types': [
      ActionTypes.EXPORT_PARTS_RETURN_ORDERS_REQUEST,
      ActionTypes.EXPORT_PARTS_RETURN_ORDERS_SUCCESS,
      [ActionTypes.EXPORT_PARTS_RETURN_ORDERS_FAILED, (error) => buildErrorMessage(error)],
    ],
    'microservice': 'part',
    'method': 'GET',
  });
};

export const clearPartsReturnOrders = () => ({
  'type': ActionTypes.CLEAR_PART_RETURNS_ORDERS_LIST,
});

export const selectPartReturnOrder = (returnOrder) => ({
  'type': ActionTypes.SELECT_PART_RETURN_ORDER,
  'payload': returnOrder,
});

export const clearPartReturnOrder = () => ({
  'type': ActionTypes.CLEAR_PART_RETURN_ORDER,
});

export const updateReturnOrderValue = (claimCode, {name, value}) => ({
  'type': ActionTypes.UPDATE_PART_RETURN_ORDER_VALUE,
  'payload': {claimCode, name, value},
});
